export enum UserStatusEnum {
  USER_NOT_CONFIRMED = '0045',
}
